/**
 * Advertorials y páginas de producto · Doctor Branson
 * Componentes animados: carruseles, desplegables suaves, pestañas, línea de tiempo por scroll,
 * contadores, aparición al hacer scroll, ventanas emergentes y compra directa.
 * Todo funciona también dentro del personalizador de Shopify.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = document.documentElement.classList.contains('shopify-design-mode');

  function $all(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ---------------------------------------------------------------- Carruseles */
  function initSlider(root) {
    if (root._advSlider) root._advSlider.destroy();
    var track = root.querySelector('[data-adv-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('[data-adv-prev]');
    var next = root.querySelector('[data-adv-next]');
    var dotsWrap = root.querySelector('[data-adv-dots]');
    var thumbs = $all(root, '[data-adv-thumb]');
    var dots = [];
    var current = 0;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function stops() {
      var max = maxScroll();
      var list = [];
      slides.forEach(function (s, i) {
        var left = s.offsetLeft - slides[0].offsetLeft;
        if (left <= max + 4) list.push(i);
      });
      if (!list.length) list.push(0);
      return list;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var st = stops();
      if (st.length < 2) return;
      st.forEach(function (idx, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'adv-slider__dot';
        b.setAttribute('aria-label', 'Ir a ' + (n + 1));
        b.addEventListener('click', function () { goTo(idx); });
        dotsWrap.appendChild(b);
        dots.push({ el: b, idx: idx });
      });
    }

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var left = slides[i].offsetLeft - slides[0].offsetLeft;
      track.scrollTo({ left: Math.min(left, maxScroll()), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function update() {
      var x = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - slides[0].offsetLeft - x);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (x >= maxScroll() - 4) best = stops()[stops().length - 1];
      current = best;
      var overflow = maxScroll() > 4;
      root.classList.toggle('is-static', !overflow);
      if (prev) prev.disabled = x <= 4;
      if (next) next.disabled = x >= maxScroll() - 4;
      var activeDot = 0;
      dots.forEach(function (d, n) { if (d.idx <= current) activeDot = n; });
      dots.forEach(function (d, n) { d.el.classList.toggle('is-active', n === activeDot); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-adv-thumb'), 10) === current); });
    }

    var raf = 0;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }
    function onPrev() {
      var st = stops();
      var pos = st.filter(function (i) { return i < current; });
      goTo(pos.length ? pos[pos.length - 1] : 0);
    }
    function onNext() {
      var st = stops();
      var pos = st.filter(function (i) { return i > current; });
      goTo(pos.length ? pos[0] : st[st.length - 1]);
    }
    function onResize() { buildDots(); update(); }

    track.addEventListener('scroll', onScroll, { passive: true });
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-adv-thumb'), 10)); });
    });
    window.addEventListener('resize', onResize);
    buildDots();
    update();

    root._advSlider = {
      destroy: function () {
        track.removeEventListener('scroll', onScroll);
        if (prev) prev.removeEventListener('click', onPrev);
        if (next) next.removeEventListener('click', onNext);
        window.removeEventListener('resize', onResize);
      }
    };
  }

  /* ---------------------------------------------------------------- Desplegables suaves */
  function initAccordion(det) {
    if (det._advAcc) return;
    det._advAcc = true;
    var summary = det.querySelector('summary');
    var body = det.querySelector('.adv-acc__body');
    if (!summary || !body) return;

    function close(d) {
      var b = d.querySelector('.adv-acc__body');
      if (!d.open || !b) return;
      if (reduceMotion) { d.open = false; return; }
      b.style.height = b.scrollHeight + 'px';
      requestAnimationFrame(function () {
        d.classList.add('is-closing');
        b.style.height = '0px';
      });
      b.addEventListener('transitionend', function te() {
        b.removeEventListener('transitionend', te);
        d.open = false;
        d.classList.remove('is-closing');
        b.style.height = '';
      });
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (det.open) {
        close(det);
        return;
      }
      var group = det.getAttribute('data-adv-acc-group');
      if (group) {
        $all(document, 'details[data-adv-acc-group="' + group + '"]').forEach(function (o) {
          if (o !== det) close(o);
        });
      }
      det.open = true;
      if (reduceMotion) return;
      var h = body.scrollHeight;
      body.style.height = '0px';
      requestAnimationFrame(function () {
        body.style.height = h + 'px';
      });
      body.addEventListener('transitionend', function te() {
        body.removeEventListener('transitionend', te);
        body.style.height = '';
      });
    });
  }

  /* ---------------------------------------------------------------- Pestañas */
  function initTabs(root) {
    var tabs = $all(root, '[data-adv-tab]');
    var panels = $all(root, '[data-adv-panel]');
    tabs.forEach(function (tab, i) {
      if (tab._advTab) return;
      tab._advTab = true;
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[n].focus();
          select(n);
        }
      });
    });
    function select(i) {
      tabs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      panels.forEach(function (p, n) {
        if (n === i) {
          p.hidden = false;
          requestAnimationFrame(function () { p.classList.add('is-active'); });
        } else {
          p.classList.remove('is-active');
          p.hidden = true;
        }
      });
    }
  }

  /* ---------------------------------------------------------------- Línea de tiempo por scroll */
  var timelines = [];
  function initTimeline(el) {
    if (timelines.indexOf(el) === -1) timelines.push(el);
    updateTimelines();
  }
  function updateTimelines() {
    var vh = window.innerHeight;
    var trigger = vh * 0.62;
    timelines.forEach(function (el) {
      if (!el.isConnected) return;
      var fill = el.querySelector('[data-adv-fill]');
      var steps = $all(el, '[data-adv-step]');
      if (designMode || reduceMotion) {
        if (fill) fill.style.height = '100%';
        steps.forEach(function (s) { s.classList.add('is-active'); });
        return;
      }
      var r = el.getBoundingClientRect();
      var p = (trigger - r.top) / Math.max(1, r.height);
      p = Math.max(0, Math.min(1, p));
      if (fill) fill.style.height = (p * 100).toFixed(2) + '%';
      steps.forEach(function (s) {
        var dot = s.querySelector('.adv-stl__dot') || s;
        s.classList.toggle('is-active', dot.getBoundingClientRect().top < trigger);
      });
    });
  }

  /* ---------------------------------------------------------------- Contadores */
  function initCount(el) {
    if (el._advCount) return;
    el._advCount = true;
    var raw = el.textContent.trim();
    var m = /^([^\d]*)(\d+(?:[.,]\d+)?)(.*)$/.exec(raw);
    if (!m || reduceMotion || designMode) return;
    var prefix = m[1];
    var numStr = m[2];
    var suffix = m[3];
    var decimals = (numStr.split(/[.,]/)[1] || '').length;
    var sep = numStr.indexOf(',') > -1 ? ',' : '.';
    var target = parseFloat(numStr.replace(',', '.'));
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        var start = null;
        var dur = 1400;
        function step(ts) {
          if (!start) start = ts;
          var t = Math.min(1, (ts - start) / dur);
          var eased = 1 - Math.pow(1 - t, 3);
          var val = (target * eased).toFixed(decimals).replace('.', sep);
          el.textContent = prefix + val + suffix;
          if (t < 1) requestAnimationFrame(step);
          else el.textContent = raw;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    el.textContent = prefix + (0).toFixed(decimals).replace('.', sep) + suffix;
    io.observe(el);
  }

  /* ---------------------------------------------------------------- Aparición al hacer scroll */
  function initReveal() {
    var flag = document.querySelector('[data-adv-reveal]');
    if (!flag || flag.getAttribute('data-adv-reveal') !== 'true') return;
    if (designMode || reduceMotion || !('IntersectionObserver' in window)) return;
    var els = $all(document, '.adv-section, .adv-marquee').filter(function (s) {
      return s.getBoundingClientRect().top > window.innerHeight * 0.9;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-revealed');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (s) {
      s.classList.add('adv-will-reveal');
      io.observe(s);
    });
  }

  /* ---------------------------------------------------------------- Ventanas emergentes */
  function initDialogs(root) {
    $all(root, '[data-adv-dialog-open]').forEach(function (btn) {
      if (btn._advDlg) return;
      btn._advDlg = true;
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.getAttribute('data-adv-dialog-open'));
        if (d && typeof d.showModal === 'function') d.showModal();
        else if (d) d.setAttribute('open', '');
      });
    });
    $all(root, 'dialog.adv-dialog').forEach(function (d) {
      if (d._advDlg) return;
      d._advDlg = true;
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-adv-dialog-close]')) {
          if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
        }
      });
    });
  }

  /* ---------------------------------------------------------------- Opciones y compra */
  /* ---------- Bloque de compra: opciones, packs, regalos y casillas ---------- */
  function advMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || '');
    }
  }

  function campaignParams() {
    var keep = new URLSearchParams();
    try {
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        if (/^(utm_[a-z_]+|fbclid|gclid|ttclid|discount)$/i.test(k)) keep.set(k, v);
      });
    } catch (e) {}
    return keep;
  }

  function buyState(form) {
    var main = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    var packInput = form.querySelector('input[name="adv_pack"]:checked');
    var pack = packInput ? packInput.closest('[data-adv-pack]') : null;
    var hasPacks = !!form.querySelector('[data-adv-pack]');
    var packIndex = pack ? parseInt(pack.getAttribute('data-index'), 10) : 0;
    var includeMain = !pack || pack.getAttribute('data-main') === 'true';
    var packItems = pack ? (pack.getAttribute('data-items') || '').split(',').filter(Boolean) : [];
    var packPaid = pack ? parseInt(pack.getAttribute('data-paid-count') || '0', 10) : 0;
    /* Lo que se paga va primero y los regalos de 0 € al final: así el checkout muestra arriba el producto principal. */
    var lines = [];
    var freeLines = [];
    function pushLine(id, price) {
      if (price > 0) lines.push(id); else freeLines.push(id);
    }
    var total = 0;
    var compare = 0;
    if (main && includeMain) {
      lines.push(main.value);
      total += parseInt(main.getAttribute('data-price') || '0', 10);
      compare += parseInt(main.getAttribute('data-compare') || main.getAttribute('data-price') || '0', 10);
    }
    if (pack) {
      total += parseInt(pack.getAttribute('data-extra') || '0', 10);
      compare += parseInt(pack.getAttribute('data-extra-compare') || '0', 10);
      var pct = parseInt(pack.getAttribute('data-pct') || '0', 10);
      if (pct > 0) total = Math.round(total * (100 - pct) / 100);
      packItems.forEach(function (id, i) { pushLine(id, i < packPaid ? 1 : 0); });
    }
    var simplePack = !!pack && packItems.length === 0;
    $all(form, '[data-adv-gift]').forEach(function (box) {
      var min = parseInt(box.getAttribute('data-min-pack') || '0', 10);
      var unlocked = !hasPacks || min === 0 || packIndex >= min;
      if (simplePack && box.getAttribute('data-hide-simple') === 'true') unlocked = false;
      if (!unlocked) return;
      $all(box, '[data-adv-gift-input]:checked').forEach(function (g) {
        pushLine(g.value, parseInt(g.getAttribute('data-price') || '0', 10));
        total += parseInt(g.getAttribute('data-price') || '0', 10);
      });
    });
    $all(form, '[data-adv-bump]').forEach(function (bump) {
      if (!bump.checked || bump.disabled) return;
      pushLine(bump.value, parseInt(bump.getAttribute('data-price') || '0', 10));
      total += parseInt(bump.getAttribute('data-price') || '0', 10);
      compare += parseInt(bump.getAttribute('data-compare') || bump.getAttribute('data-price') || '0', 10);
    });
    /* Shopify muestra las líneas del pedido en orden inverso al que se envían:
       se mandan al revés para que en el checkout salga arriba lo que se paga. */
    lines = lines.concat(freeLines).reverse();
    return {
      lines: lines,
      total: total,
      compare: compare,
      code: pack ? (pack.getAttribute('data-code') || '') : '',
      packIndex: packIndex,
      packItems: packItems,
      hasPacks: hasPacks,
      simplePack: simplePack,
      variant: main ? main.value : ''
    };
  }

  function refreshBuyForm(form) {
    var st = buyState(form);
    $all(form, '[data-adv-offercard]').forEach(function (c) {
      var input = c.querySelector('input[type="radio"]');
      c.classList.toggle('is-selected', !!(input && input.checked));
    });
    $all(form, '[data-adv-gift]').forEach(function (box) {
      var min = parseInt(box.getAttribute('data-min-pack') || '0', 10);
      var unlocked = !st.hasPacks || min === 0 || st.packIndex >= min;
      var hideSimple = st.simplePack && box.getAttribute('data-hide-simple') === 'true';
      box.hidden = hideSimple;
      if (hideSimple) unlocked = false;
      box.classList.toggle('is-locked', !unlocked && !hideSimple);
      $all(box, '[data-adv-gift-lock]').forEach(function (el) { el.hidden = unlocked; });
      $all(box, '[data-adv-gift-open]').forEach(function (el) { el.hidden = !unlocked && !!box.querySelector('[data-adv-gift-lock]'); });
      $all(box, '[data-adv-gift-input]').forEach(function (g) {
        g.disabled = !unlocked;
        var lbl = g.closest('.adv-gift');
        if (lbl) lbl.classList.toggle('is-selected', g.checked && unlocked);
      });
    });
    $all(form, '[data-adv-bump]').forEach(function (bump) {
      var included = st.packItems.indexOf(bump.value) !== -1;
      var wrap = bump.closest('[data-adv-bump-wrap]');
      bump.disabled = included;
      if (wrap) {
        wrap.classList.toggle('is-included', included);
        wrap.classList.toggle('is-checked', bump.checked && !included);
        var incl = wrap.querySelector('.adv-bump__incl');
        if (incl) incl.hidden = !included;
      }
    });
    var cur = form.getAttribute('data-currency') || 'EUR';
    $all(form, '[data-adv-total]').forEach(function (el) { el.textContent = advMoney(st.total, cur); });
    $all(form, '[data-adv-total-compare]').forEach(function (el) {
      el.textContent = st.compare > st.total ? advMoney(st.compare, cur) : '';
    });
    return st;
  }

  function initBuyForm(form) {
    if (form._advBuy) return;
    form._advBuy = true;
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-adv-gift-input]') && t.checked) {
        var box = t.closest('[data-adv-gift]');
        var max = parseInt(box.getAttribute('data-max') || '1', 10);
        var checked = $all(box, '[data-adv-gift-input]:checked');
        if (checked.length > max) {
          checked.forEach(function (g) {
            if (g !== t && $all(box, '[data-adv-gift-input]:checked').length > max) g.checked = false;
          });
        }
      }
      refreshBuyForm(form);
    });
    refreshBuyForm(form);

    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('[data-adv-buy]');
      var mode = btn ? btn.getAttribute('data-adv-buy') : 'cart';
      var st = buyState(form);
      try {
        var detail = { position: 'comprar', destination: mode, variant: st.variant, lines: st.lines.length, value: st.total / 100, page: window.location.pathname };
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('adv_cta_click', detail);
        }
      } catch (err) {}
      if (designMode || !st.lines.length) return;
      e.preventDefault();
      if (btn) btn.classList.add('is-loading');

      var params = campaignParams();
      if (st.code) {
        var existing = params.get('discount');
        params.set('discount', existing ? st.code + ',' + existing : st.code);
      }

      if (mode === 'checkout') {
        var counts = {};
        var order = [];
        st.lines.forEach(function (id) {
          if (!counts[id]) { counts[id] = 0; order.push(id); }
          counts[id] += 1;
        });
        var url = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/' + order.map(function (id) { return id + ':' + counts[id]; }).join(',');
        var qs = params.toString();
        window.location.href = qs ? url + '?' + qs : url;
        return;
      }

      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: st.lines.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          var code = params.get('discount');
          var r0 = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'); window.location.href = code ? r0 + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(r0 + 'cart') : r0 + 'cart';
        })
        .catch(function () {
          if (btn) btn.classList.remove('is-loading');
          form.submit();
        });
    });
  }


  /* ---------------------------------------------------------------- Inicio */
  /* Menú móvil de la cabecera del sitio */
  function initMenu(hdr) {
    if (hdr._advMenu) return;
    hdr._advMenu = true;
    var btn = hdr.querySelector('[data-adv-menu-toggle]');
    if (!btn) return;
    function set(open) {
      hdr.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    }
    btn.addEventListener('click', function () { set(!hdr.classList.contains('is-open')); });
    hdr.addEventListener('click', function (e) {
      if (e.target.closest('[data-adv-menu-link]') || e.target.closest('.adv-shdr__cta-mobile')) set(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    document.addEventListener('click', function (e) { if (!hdr.contains(e.target)) set(false); });
  }

  function init(root) {
    root = root || document;
    $all(root, '[data-adv-slider]').forEach(initSlider);
    $all(root, 'details[data-adv-acc]').forEach(initAccordion);
    $all(root, '[data-adv-tabs]').forEach(initTabs);
    $all(root, '[data-adv-timeline]').forEach(initTimeline);
    $all(root, '[data-adv-count]').forEach(initCount);
    $all(root, 'form[data-adv-buyform]').forEach(initBuyForm);
    $all(root, '[data-adv-menu]').forEach(initMenu);
    initDialogs(root);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; updateTimelines(); });
  }, { passive: true });
  window.addEventListener('resize', updateTimelines);

  function boot() {
    init(document);
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var det = e.target.closest && e.target.closest('details');
    if (det) det.open = true;
    var slider = e.target.closest && e.target.closest('[data-adv-slider]');
    var track = slider && slider.querySelector('[data-adv-track]');
    if (track && track.contains(e.target)) {
      track.scrollTo({ left: e.target.offsetLeft - track.children[0].offsetLeft, behavior: 'smooth' });
    }
    var tab = e.target.matches && e.target.matches('[data-adv-tab]') ? e.target : null;
    if (tab) tab.click();
  });
})();

